import {useQueries} from "@tanstack/react-query";
import CompressionService from "../../../../services/web/compression-service.js";

const UseFetchData = () => {
    const queries = useQueries({
        queries: [
            {
                queryKey: ['dimensions'],
                queryFn: () => CompressionService.getDimensions().then(data => data.map(({ id, text}) => ({ value: id, label: text})))
            },
            {
                queryKey: ['lanes'],
                queryFn: () => CompressionService.getPreviewLanes().then(data => data.map(({ id, text }) => ({ value: id, label: text })))
            },
        ]
    });

    return {
        dimensions: queries[0].data ?? [],
        lanes: queries[1].data ?? [],
    }
};

export default UseFetchData;